var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagaLogoColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 26,
    viewBox: "0 0 92 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.08179V6.87619H6.38741V19.4989C8.46887 18.7821 10.6127 18.1057 12.8133 17.4715V6.87619H19.1916V1.08179H0Z",
    fill: "url(#paint0_linear_198_77938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2349 13.0004C68.2125 16.7031 66.9421 19.7918 64.4255 22.2609C61.8734 24.7536 58.673 26 54.8281 26C51.1157 26 47.9658 24.77 45.3801 22.3081C43.1904 20.2151 41.9237 17.7242 41.58 14.8354C43.6706 14.5374 45.7892 14.2722 47.9378 14.0451C48.0854 15.7311 48.687 17.1646 49.7388 18.3438C51.0317 19.7936 52.7169 20.5204 54.7944 20.5204C56.2424 20.5204 57.4904 20.2024 58.5404 19.5683C59.6688 18.8815 60.4199 17.8859 60.7954 16.5869H56.5432V13.3329C59.6875 13.1475 62.8804 13.0367 66.1144 13.0076C66.8225 13.0004 67.5306 12.9986 68.2349 13.0004Z",
    fill: "url(#paint1_linear_198_77938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1692 9.03891H60.0781C58.879 6.83574 57.0593 5.7332 54.6188 5.7332C52.637 5.7332 51.0033 6.46506 49.7177 7.92497C48.8336 8.93437 48.2626 10.111 48.0103 11.4512C45.8443 11.5671 43.6985 11.723 41.5804 11.9169C41.8364 8.68154 43.122 5.9404 45.4354 3.6935C47.9845 1.2299 51.1009 0 54.7828 0C57.5289 0 60.0725 0.825002 62.4135 2.47881C64.8429 4.18774 66.4287 6.37381 67.1692 9.03891Z",
    fill: "url(#paint2_linear_198_77938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.648 24.9181H35.5588L34.3097 21.4773H25.4307L24.0801 24.9181H17.0592L19.3804 19.5327C22.9656 18.4531 26.715 17.4915 30.6064 16.655L32.4627 16.2671C34.4333 15.8667 36.4408 15.5003 38.4797 15.1679L42.648 24.9181Z",
    fill: "url(#paint3_linear_198_77938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3175 12.5769C35.3289 12.8007 33.3663 13.0576 31.4298 13.3456L29.9495 8.6914H29.8471L28.2048 13.8556C25.8679 14.2482 23.5739 14.6848 21.3246 15.1654L27.2924 1.08179H32.4874L37.3175 12.5769Z",
    fill: "url(#paint4_linear_198_77938)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92 25.2796H85.0364L83.8094 21.7344H75.0877L73.7627 25.2796H66.8644L71.9611 12.876C73.7283 12.9184 75.481 12.9884 77.2174 13.0841L77.2572 12.9423C77.2681 12.9037 77.2536 12.8631 77.2228 12.8374L76.2712 12.0915C75.0025 11.9552 73.7229 11.8318 72.4342 11.7232L76.9455 0.743215H82.0023L92 25.2796ZM81.9103 12.9422C81.8994 12.9035 81.9121 12.863 81.9429 12.8372L81.9791 12.8078H81.9809L84.9117 10.5131C84.9842 10.456 84.9462 10.3399 84.8537 10.3363L81.0765 10.1889C81.0366 10.1871 81.0004 10.1613 80.9877 10.1245L79.6773 6.60506C79.6447 6.5185 79.5214 6.5185 79.4906 6.60506L78.1802 10.1245C78.1657 10.1613 78.1312 10.1871 78.0913 10.1889L74.3141 10.3363C74.2217 10.3399 74.1836 10.456 74.2561 10.5131L76.2712 12.0915L77.2228 12.8374C77.2536 12.8631 77.2681 12.9037 77.2572 12.9423L77.2174 13.0841L76.2335 16.5537C76.2082 16.6421 76.3078 16.7121 76.384 16.6623L77.0057 16.2516V16.2498L79.5286 14.5794C79.5613 14.5573 79.6048 14.5573 79.6392 14.5794L82.7821 16.6623C82.86 16.7121 82.9597 16.6421 82.9343 16.5537L81.9103 12.9422Z",
    fill: "url(#paint5_linear_198_77938)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_198_77938",
    x1: 2.36489e-7,
    y1: -0.00035315,
    x2: 91.0468,
    y2: 28.9937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0051F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_198_77938",
    x1: 2.36489e-7,
    y1: -0.00035315,
    x2: 91.0468,
    y2: 28.9937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0051F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_198_77938",
    x1: 2.36489e-7,
    y1: -0.00035315,
    x2: 91.0468,
    y2: 28.9937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0051F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_198_77938",
    x1: 2.36489e-7,
    y1: -0.00035315,
    x2: 91.0468,
    y2: 28.9937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0051F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_198_77938",
    x1: 2.36489e-7,
    y1: -0.00035315,
    x2: 91.0468,
    y2: 28.9937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0051F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_198_77938",
    x1: 2.36489e-7,
    y1: -0.00035315,
    x2: 91.0468,
    y2: 28.9937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0051F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagaLogoColor);
export default __webpack_public_path__ + "static/media/taga-logo-color.b885726bbd2ca303030d5df9f5d5a077.svg";
export { ForwardRef as ReactComponent };